module.exports = __webpack_public_path__ + "media/images/download-95b4824e3d447583ced60ff4add6e70a.png";